module.exports = __webpack_public_path__ + "img/temperature-thermometer.168429f8.svg";